import { bl_aat_engagement_hdr_RowClass, bl_fi_entity_hdr_RowClass, bl_fi_mst_branch_RowClass, bl_fi_mst_comp_RowCLass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class EngagementHdrCustomContainerModel extends BaseContainerModel {
    bl_aat_engagement_hdr: bl_aat_engagement_hdr_RowClass = new bl_aat_engagement_hdr_RowClass();
    bl_fi_mst_comp: bl_fi_mst_comp_RowCLass = new bl_fi_mst_comp_RowCLass();
    bl_fi_mst_branch: bl_fi_mst_branch_RowClass = new bl_fi_mst_branch_RowClass();
    bl_fi_mst_entity_hdr: bl_fi_entity_hdr_RowClass = new bl_fi_entity_hdr_RowClass();
}